import React, { useState } from 'react';
import { EItemButtons, EUserType, ITypeaheadButton, ITypeaheadList, optionContactConfigFromContacts } from '../../../domain/typeahead.interfaces';
import { typeaheadItemFormatter } from '../../../utils/formatter';
import { TypeaheadUserComponent } from '../typeahead-user/TypeaheadUser.component';
import { ERoutes } from '../../../assets/constants/routes';
import { IContactComplete } from '../../../domain/contact.interface';
import _ from 'lodash';

export function TypeaheadUserContactComponent(props: any) {

  const { onClickContact, onClickUser, contacts } = props;

  const [filteredContacts, setFilteredContacts] = useState<IContactComplete[]>([]);

  const buttonsUserConfig: ITypeaheadButton[] = [
    { icon: 'user-edit', action: onClickUser }
  ];

  const buttonsContactConfig: ITypeaheadButton[] = [
    { icon: 'user-edit', action: onClickContact }
  ];

  function accessToWishList(item: any) {
    props.history.push({
      pathname: ERoutes.CONTACT_WISH_LIST_CATALOGUE,
      state: {
        contact: accessToWishListCatalogueFormatter(item),
        readOnly: true,
      }
    });
  }

  function onContactItemClick(item: any) {
    return (item.user && item.user.active) ?
      accessToWishList(item) :
      onClickContact(item);
  }

  function accessToWishListCatalogueFormatter(item: any) {
    let itemFormatted: {
      id: string;
      name?: string;
      alias?: string;
      nickname: string | undefined;
    };
    itemFormatted = {
      id: !!item.user ? item.user.id : item.id,
      alias: item.alias,
      name: !!item.user ? item.user.name : item.name,
      nickname: !!item.user ? item.user.nickname : item.nickname,
    };
    return itemFormatted;
  }

  const onExpandTypeaheadOptions = (userOption: ITypeaheadList) => {

    const apiContacts = filteredContacts.map((el: any) => {
      const userType = el.user.isActive
        ? EUserType.CONTACT
        : EUserType.INACTIVE;
      const unallowedButtons = el.user.isActive ? [] : [EItemButtons.WISHLIST];
      return typeaheadItemFormatter(
        optionContactConfigFromContacts,
        el,
        userType,
        unallowedButtons,
      );
    });

    return [
      {
        title: 'contacts',
        data: apiContacts,
        buttons: buttonsContactConfig,
        onClickAction: onContactItemClick
      },
      { ...userOption, buttons: buttonsUserConfig, onClickAction: accessToWishList }
    ];
  };

  const onQuery = (query: string) => {
    setFilteredContacts(
      contacts.filter(
        (contact: IContactComplete) => {
          return _.includes(contact.alias.toLowerCase(), query.toLowerCase()) ||
            _.includes(contact.user.nickname.toLowerCase(), query.toLowerCase());
        }
      )
    );
  };

  const onCancelQuery = () => {
    setFilteredContacts([]);
  };

  const onBlur = () => {
    setFilteredContacts([]);
  };

  return (
    <TypeaheadUserComponent
      onBlur={onBlur}
      onQuery={onQuery}
      onCancelQuery={onCancelQuery}
      onExpandTypeaheadOptions={onExpandTypeaheadOptions}
    />
  );
}
